import { useEffect, useSyncExternalStore, type ReactNode } from 'react';

import {
  boot,
  estInactif,
  getSessionState,
  logout,
  noterActivite,
  subscribeSession,
  type SessionState,
} from './session';

/** État de session courant, mis à jour à chaque connexion ou déconnexion. */
export function useSession(): SessionState {
  return useSyncExternalStore(subscribeSession, getSessionState, getSessionState);
}

/**
 * Démarre la session (reprise de l'onglet) et surveille l'inactivité :
 * au-delà de 8 h sans clic ni frappe, la session est fermée.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const { status } = useSession();

  useEffect(() => {
    void boot();
  }, []);

  useEffect(() => {
    if (status !== 'authenticated') return;
    const activite = () => noterActivite();
    window.addEventListener('pointerdown', activite);
    window.addEventListener('keydown', activite);
    const minuteur = window.setInterval(() => {
      if (estInactif()) logout('Session fermée après 8 h d’inactivité.');
    }, 60_000);
    return () => {
      window.removeEventListener('pointerdown', activite);
      window.removeEventListener('keydown', activite);
      window.clearInterval(minuteur);
    };
  }, [status]);

  return <>{children}</>;
}
